import { Box, Button, Menu, SpeedDialAction, Tooltip, tooltipClasses } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { display, fontWeight } from "@mui/system";
import { thirdly6 } from "styles/theme";
import { black } from "styles/theme";

export const CategoriesOptionsStyles = muiStyled(Box)(({ theme, color, borderStyle = "solid", borderColor }) => ({
    padding: 10,
    display: "flex",
    columnGap: 10,
    flexDirection: "column",
    rowGap: 10,
    maxHeight: '60vh', // גובה מקסימלי אוטומטי (כמו ב-MUI המקורי)
    overflowY: 'auto', // מאפשר גלילה פנימית אם יש הרבה קטגוריות
    '.active-icon': {
        '& path': { // ה-& מבטיח שאנחנו פונים ל-path שבתוך האלמנט עם ה-class הזה
            fill: thirdly6,
            // stroke: thirdly6 
        }
    },
    '.group-and-categories': {
        display: "flex",
        columnGap: 10,
        flexDirection: "column",
        rowGap: 10,
    },
    '.categories': {
        display: "flex"
    },
    '.MuiButtonBase-root.MuiButton-root.MuiLoadingButton-root': {
        fontSize: 14
    },
    '.ability-group-name': {
        fontSize: 16,
        fontWeight: "bold"
    },
    '.ability-item': {
        display: "flex",
        columnGap: 7,
        alignItems: "center"
    },
    '.category-item': {

    },
    '.group-categories': {
        display: "flex",
        columnGap: 7,
        width: "100%",
        flexWrap: "wrap",
        rowGap: 7
    }
}))
